/**
 * Gate for authenticated routes. While the session is resolving we render a
 * lightweight loading state; once resolved, unauthenticated users are sent to
 * /login (preserving the attempted location for post-login return).
 */
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useAuth } from './store';

export function ProtectedRoute(): JSX.Element {
  const { user, isAuthenticated } = useAuth();
  const location = useLocation();

  // Session still resolving on boot.
  if (user === undefined) {
    return (
      <div className="center-screen">
        <p className="muted">Loading…</p>
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" replace state={{ from: location }} />;
  }

  return <Outlet />;
}
